import React from "react";
import "./Footer.css";

let Footer = () => (
  <div>
  <div class="section footer-classic context-dark bg-image pt-4 bg-warning" >
  <div class="container">
    <div class="row row-30">
      <div class="col-md-4 col-xl-5">
        <div class="pr-xl-4"><a class="brand" href="index.html"><img class="brand-logo-light" src="images/agency/logo-inverse-140x37.png" alt="" width="140" height="37" srcset="images/agency/logo-retina-inverse-280x74.png 2x"/></a>
          <p>GOOD MORNING BAMBOO will be a fully integrated eco-city. It is master planned to seamlessly intertwine industrial areas, such as factories, workshops, yards, and the Logistics Zone, with vibrant residential, Training/educational, commercial and tourism areas.</p>
          
          <p class="rights"><span>©  </span><span class="copyright-year">2019</span><span> </span><span>Good Morning Bamboo</span><span>. </span><span>All Rights Reserved.</span><br/><span>Website Developed by <a className="text-dark" href="https://samuelowusuafriyie.github.io/portfolio/">Bliza Samuel</a></span></p>
        </div>
      </div>
      <div class="col-md-4">
        <h5>Contacts</h5>
        <dl class="contact-list">
          <dt>Address:</dt>
          <dd>P. O. Box 2703, Sunyani, Ghana.</dd>
        </dl>
        <dl class="contact-list">
          <dt>email:</dt>
          <dd><a className="text-dark" href="mailto:#"> samuel.worwui@gmail.com</a></dd>
        </dl>
        <dl class="contact-list">
          <dt>phones:</dt>
          <dd><a className="text-dark" href="tel:#">+233509160497</a> <span>or</span> <a className="text-dark" href="tel:#">+23352195223</a>
          </dd>
        </dl>
      </div>
      <div class="col-md-4 col-xl-3">
        <h5>Links</h5>
        <ul class="nav-list ">
          <li><a className="text-dark" href="home.html">Home</a></li>
          <li><a className="text-dark" href="gallery.html">About Us</a></li>
          <li><a className="text-dark" href="contact.html">Contact Us</a></li>
        </ul>
      </div>
    </div>
  </div>
  <div class="row no-gutters social-container">
    <div class="col"><a class="social-inner text-dark" href="#"><span class="icon mdi mdi-facebook"></span><span>Facebook</span></a></div>
    <div class="col"><a class="social-inner text-dark" href="#"><span class="icon mdi mdi-instagram"></span><span>instagram</span></a></div>
    <div class="col"><a class="social-inner text-dark" href="#"><span class="icon mdi mdi-twitter"></span><span>twitter</span></a></div>
    <div class="col"><a class="social-inner text-dark" href="#"><span class="icon mdi mdi-youtube-play"></span><span>google</span></a></div>
  </div>
</div>
</div>
)
export default Footer;
